module.exports = __webpack_public_path__ + "img/img_noimage.d3f58ed1.png";